module.exports = __webpack_public_path__ + "img/ads6.5a113c4.webp";